import * as React from "react";
import { deviceTemp, deviceVoltage, externalTemp } from "../../store/apis/devicesApi";
import Box from "@mui/material/Box";
import { LineChart, lineElementClasses, markElementClasses } from "@mui/x-charts/LineChart";
import { LineSeriesType } from "@mui/x-charts/models";
import Typography from "@mui/material/Typography";
export const RenderLineChart = ({
  data,
  title,
}: {
  data?: deviceTemp[] | externalTemp[] | deviceVoltage[];
  title: string;
}) => {
  if (!data) return <div />;

  const timeData = data.map((d) => new Date(d.timestamp));
  const values = data.map((d) => ("temp" in d ? d.temp.toFixed(1) : d.voltage));

  const config = {
    series: [{ type: "line", data: values }] as LineSeriesType[],
    height: 400,
    xAxis: [
      {
        data: timeData,
        scaleType: "time",
        valueFormatter: (date: Date) =>
          date.getHours() === 0
            ? date.toLocaleDateString("fi-FI", {
                month: "2-digit",
                day: "2-digit",
              })
            : date.toLocaleTimeString("fi-FI", {
                hour: "2-digit",
                minute: "2-digit",
              }),
      } as const,
    ],
  };

  return (
    <Box sx={{ width: "100%", maxWidth: "100%" }}>
      <br />
      <Typography marginBottom={"-50px"} align={"center"} variant={"h6"}>
        {title}
      </Typography>
      <LineChart
        {...config}
        sx={{
          [`& .${lineElementClasses.root}`]: {
            stroke: "#8884d8",
            strokeWidth: 2,
          },
          [`& .${markElementClasses.root}`]: {
            stroke: "#8884d8",
            scale: "0.3",
            fill: "#fff",
            strokeWidth: 2,
          },
        }}
      />
    </Box>
  );
};
